/**
 * Tabs
 * ------
 */

$b.on('click', '.tabs nav a', function(e){
  e.preventDefault();
  $(this).closest('.tabs').find('nav li.' + site.ac + ', .tab-panel.' + site.ac).removeClass(site.ac);
  $(this).closest('li').addClass(site.ac);
  $($(this).attr('href')).addClass(site.ac);
});